import { brandAssets } from '@/config/brandAssets'
import { cn } from '@/lib/cn'

export interface AppLoaderProps {
  /** Caption under the mark. */
  label?: string
  /** Fill the viewport (app start, route chunks) or just the parent. */
  fullScreen?: boolean
  className?: string
}

/**
 * Branded wait for app start and route-level loads: the KAAMCO mark inside the
 * sweeping dial, with a shift-bar rule filling and draining underneath.
 */
export function AppLoader({
  label = 'Getting your workspace ready',
  fullScreen = true,
  className,
}: AppLoaderProps): React.ReactElement {
  return (
    <div
      role="status"
      aria-label={label}
      className={cn(
        'flex flex-col items-center justify-center gap-5 bg-bg-base px-6 text-primary dark:bg-gray-900 dark:text-sky-400',
        fullScreen ? 'min-h-screen' : 'min-h-[50vh]',
        className
      )}
    >
      <div className="kc-loader-in relative grid h-20 w-20 place-items-center">
        <svg viewBox="0 0 80 80" fill="none" className="absolute inset-0 h-full w-full" aria-hidden data-loading="">
          <circle cx="40" cy="40" r="37" stroke="currentColor" strokeOpacity="0.12" strokeWidth="2" />
          <g className="kc-sweep__hand" style={{ transformOrigin: '40px 40px' }}>
            <circle
              className="kc-sweep__trail"
              cx="40"
              cy="40"
              r="37"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              pathLength="100"
              transform="translate(80 0) scale(-1 1) rotate(-90 40 40)"
            />
            <circle cx="40" cy="3" r="3" fill="currentColor" />
          </g>
        </svg>
        <img src={brandAssets.logo} alt="" className="h-10 w-10 object-contain" />
      </div>
      <div className="kc-loader-in flex flex-col items-center gap-3">
        <span className="kc-boot__bar" aria-hidden />
        <span className="text-xs font-medium text-gray-500 dark:text-gray-400">{label}</span>
      </div>
    </div>
  )
}

AppLoader.displayName = 'AppLoader'
